(function () {
    'use strict';

    angular
        .module('app.surveys')
        .controller('SurveyDetailsController', SurveyDetailsController);

    SurveyDetailsController.$inject = [
        '$state', '$stateParams', '$window',
        'bootstrap.dialog', 'common', 'dataservice'
    ];

    function SurveyDetailsController($state, $stateParams, $window, bsDialog, common, dataservice) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;
        vm.counts = [];
        vm.deletedQuestions = [];
        vm.deletedOptions = [];
        vm.cancel = cancel;
        vm.deleteItem = deleteItem;
        vm.isSaving = false;
        vm.save = save;
        vm.item = undefined;
        vm.isNew = isNew;
        vm.preventDelete = preventDelete;

        vm.questionClick = questionClick;
        vm.addQuestion = addQuestion;
        vm.addOption = addOption;
        vm.showMove = showMove;
        vm.moveOpt = moveOpt;
        vm.deleteOpt = deleteOpt;
        vm.deleteQuestion = deleteQuestion;
        vm.answerTypeText = answerTypeText;
        vm.isRequiredAndNotActivated = isRequiredAndNotActivated;
        vm.sendOnData = [];

        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), initLookups(), getItem(), getCounts()];

            return common.$q.all(promises).then(function (data) {

            }, function (error) { });
        }

        function cancel() {
            backToList();
        }

        function backToList() {
            $state.go("surveys.list");
        }

        function preventDelete() {
            if (vm.counts.length > 0 || $stateParams.id === "") {
                return true;
            }

            return false;
        }

        function deleteItem() {
            return bsDialog.deleteDialog('Survey')
                .then(confirmDelete, function () { });

            function confirmDelete() {
                dataservice.deleteItem("api/Surveys/" + vm.item.UId).then(success).catch(failed);

                function success() {
                    backToList();
                }

                function failed(error) {
                    logger.error(error);
                }
            }
        }

        function isNew() {
            var val = $stateParams.id;
            return val === "";
        }

        function getCounts() {
            return dataservice.getItems('api/Surveys/CountsOfEntries/' + $stateParams.id).then(function (response) {
                vm.counts = response.data;
                return vm.counts;
            }, function (error) { });
        }

        function getItem() {
            var val = $stateParams.id;
            if (val === '') {
                vm.item = {};
                vm.item.Active = 1;
                vm.item.AskStandardUsers = 1;
                vm.item.AskManagers = 1;
                vm.item.AskAdmins = 1;
                vm.item.Questions = [];
                common.setAuditInfo(vm.item);
                return vm.item;
            }

            return dataservice.getItem("api/Surveys/" + val)
                .then(function (data) {
                    if (data) {
                        vm.item = data.data;
                        if (!vm.item.Questions) {
                            vm.item.Questions = [];
                        }
                        common.setAuditInfo(vm.item);
                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }


        function initLookups() {
        }

        function save() {

            vm.isSaving = true;
            
            if (vm.deletedOptions.length > 0) {
                dataservice.saveItem('api/Surveys/DeleteQuestionItems', vm.deletedOptions).then(function (saveResult) {
                }, function (error) { });
            }

            if (vm.deletedQuestions.length > 0) {
                dataservice.saveItem('api/Surveys/DeleteQuestions', vm.deletedQuestions).then(function (saveResult) {
                }, function (error) { });
            }

            dataservice.saveItem('api/Surveys/Save', vm.item).then(function (saveResult) {
                vm.isSaving = false;
                backToList();
            }).catch(function (error) {
                vm.isSaving = false;
            });

        }

        function isRequiredAndNotActivated(question) {
            return !question.Activated && question.Required == true;
        }

        function deleteQuestion(question) {
            if (question.HasBeenAnswered) {
                var deleteMsg = "This question has been answered.  Deleting it will also delete all responses to the question.  Are you sure you want to delete this question?";

                return bsDialog.deleteDialog('Survey Question', deleteMsg, "Yes", "No").then(function () {
                    vm.deletedQuestions.push(question);
                    vm.item.Questions.splice(vm.item.Questions.indexOf(question), 1);
                }, function () { });

            }
            else {
                if (question.ID > 0) {
                    vm.deletedQuestions.push(question);
                }
                vm.item.Questions.splice(vm.item.Questions.indexOf(question), 1);
            }

        }

        function deleteOpt(question, opt) {
            if (opt.ID > 0) {

                if (question.HasBeenAnswered) {
                    var deleteMsg = "This question has been answered.  Deleting this option will also delete all responses to the question that answered with this option.  Are you sure you want to delete this option?";

                    return bsDialog.deleteDialog('Log Type', deleteMsg, "Yes", "No").then(function () {
                        vm.deletedOptions.push(opt);
                        question.Items.splice(question.Items.indexOf(opt), 1);
                    }, function () { });

                }
                else {
                    vm.deletedOptions.push(opt);
                    question.Items.splice(question.Items.indexOf(opt), 1);
                }
            }
            else {
                question.Items.splice(question.Items.indexOf(opt), 1);
            }

        }

        function showMove(dir, question, opt) {
            if (dir == -1) {
                if (question.Items.indexOf(opt) == 0) {
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                if (question.Items.indexOf(opt) == (question.Items.length - 1)) {
                    return false;
                }
                else {
                    return true;
                }
            }
        }


        function moveOpt(dir, question, opt) {
            var index = question.Items.indexOf(opt);
            var newIndex = index + dir;

            var removedElement;
            if (newIndex > -1 && newIndex < question.Items.length) {
                removedElement = question.Items.splice(index, 1)[0];
            }

            question.Items.splice(newIndex, 0, removedElement);
        }

        function questionClick(question) {
            for (var i = 0; i < vm.item.Questions.length; i++) {
                vm.item.Questions[i].Activated = false;
            }
            question.Activated = true;
        }

        function answerTypeText(question) {
            switch (question.AnswerType) {
                case 1:
                    return "Short Answer";
                case 2:
                    return "Paragraph";
                case 3:
                    return "Multiple Choice";
                case 4:
                    return "Checkboxes";
                case 5:
                    return "Dropdown";
                case 6:
                    return "Date";
                case 7:
                    return "Time"
            }
        }

        function addQuestion() {
            for (var i = 0; i < vm.item.Questions.length; i++) {
                vm.item.Questions[i].Activated = false;
            }
            var question = {};

            question.Question = "";
            question.AnswerType = 1;
            question.AnswerTypeText = "Short Answer";
            question.Items = [];
            question.Active = true;
            question.Activated = true;
            question.Sequence = vm.item.Questions.length;;
            question.Required = false;
            vm.item.Questions.push(question);
        }

        function addOption(question) {
            var i = question.Items.length + 1;
            var opt = { Description: "Option " + i, Active: true };
            question.Items.push(opt)
        }
    }
})();
